import React from "react";

/**
 * Displays the specified element on true, message otherwise
 * @param condition check condition
 * @param element Element to display when true
 * @param message Message to display when false
 */
function chartOrMessage(condition: boolean, elementWhenTrue: React.ReactNode, messageWhenFalse: string): any {
    if (condition) {
        return (
            elementWhenTrue
        );
    }

    return <div className="no-chart">{messageWhenFalse}</div>;
}

interface IOptionalProps {
    show: boolean;
    message?: string;
    children?: React.ReactNode;
}

/**
 * Component that displays the specified element on true, message otherwise
 * @param props 
 */
export function ChartOrMessage(props: IOptionalProps) {
    const { show, message, children } = props;
    return chartOrMessage(show, children, message || "No data");
}